import { useQuery } from '@tanstack/react-query';

import axois from 'src/lib/axios';

const getUser = async () => {
  const response = await axois.get('/user');
  return response.data;
};

export function useGetUserId(isAuthTokenSet: boolean) {
  const { data: user } = useQuery({
    queryKey: ['user'],
    queryFn: getUser,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: isAuthTokenSet,
  });

  return { id: user?.id };
}
